import { jsx } from "react/jsx-runtime";
import { c as classNames } from "../../../../index-e71f83b5.js";
import React__default from "react";
import { P as PropTypes, t as tagPropType, m as mapToCssModules } from "../../../../utils-65a8d69b.js";
import { COMMON_CLASSNAME } from "../../../constants.js";
import "../../../../_commonjsHelpers-0c53d963.js";
var _excluded$1 = ["className", "listClassName", "cssModule", "children", "tag", "listTag", "aria-label"];
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends$1.apply(this, arguments);
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded), key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++)
      key = sourceSymbolKeys[i], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i;
  for (i = 0; i < sourceKeys.length; i++)
    key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
var propTypes$1 = {
  /** Aria label */
  "aria-label": PropTypes.string,
  /** Pass children so this component can wrap them */
  children: PropTypes.node,
  /** Add custom class */
  className: PropTypes.string,
  /** Change existing className with a new className */
  cssModule: PropTypes.object,
  /** Add custom class to list tag */
  listClassName: PropTypes.string,
  /** Set a custom element for list tag */
  listTag: tagPropType,
  /** Set a custom element for this component */
  tag: tagPropType
};
function Breadcrumb(props) {
  var className = props.className, listClassName = props.listClassName, cssModule = props.cssModule, children = props.children, _props$tag = props.tag, Tag = _props$tag === void 0 ? "nav" : _props$tag, _props$listTag = props.listTag, ListTag = _props$listTag === void 0 ? "ol" : _props$listTag, _props$ariaLabel = props["aria-label"], label = _props$ariaLabel === void 0 ? "breadcrumb" : _props$ariaLabel, attributes = _objectWithoutProperties$1(props, _excluded$1), classes = mapToCssModules(classNames(className), cssModule), listClasses = mapToCssModules(classNames("breadcrumb", listClassName), cssModule);
  return /* @__PURE__ */ React__default.createElement(Tag, _extends$1({}, attributes, {
    className: classes,
    "aria-label": label
  }), /* @__PURE__ */ React__default.createElement(ListTag, {
    className: listClasses
  }, children));
}
Breadcrumb.propTypes = propTypes$1;
var _excluded = ["className", "cssModule", "active", "tag"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded), key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++)
      key = sourceSymbolKeys[i], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i;
  for (i = 0; i < sourceKeys.length; i++)
    key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
var propTypes = {
  /** Adds a visual "active" state to a Breadcrumb Item */
  active: PropTypes.bool,
  /** Add custom class to the element */
  className: PropTypes.string,
  /** Change existing className with a new className */
  cssModule: PropTypes.object,
  /** Set a custom element for this component */
  tag: tagPropType
};
function BreadcrumbItem(props) {
  var className = props.className, cssModule = props.cssModule, active = props.active, _props$tag = props.tag, Tag = _props$tag === void 0 ? "li" : _props$tag, attributes = _objectWithoutProperties(props, _excluded), classes = mapToCssModules(classNames(className, active ? "active" : !1, "breadcrumb-item"), cssModule);
  return /* @__PURE__ */ React__default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    "aria-current": active ? "page" : void 0
  }));
}
BreadcrumbItem.propTypes = propTypes;
function FlashBreadcrumbs(props) {
  const { breadcrumbs = [] } = props;
  return /* @__PURE__ */ jsx("div", { className: `${COMMON_CLASSNAME} flash-breadcrumbs`, children: /* @__PURE__ */ jsx(Breadcrumb, { children: breadcrumbs.map((breadcrumb, idx) => /* @__PURE__ */ jsx(
    BreadcrumbItem,
    {
      ...breadcrumb,
      className: classNames(
        {
          "text-secondary": !breadcrumb.active
        },
        breadcrumb.className
      )
    },
    idx
  )) }) });
}
export {
  FlashBreadcrumbs as default
};
//# sourceMappingURL=FlashBreadcrumbs.js.map
